
































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import UUIFComponent from '@/shared/uuifComponent';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { detectIE } from '@/shared/env.config';
const cssPrefix = 'prefrencefile';
@Component({
  components: {
    ...UUIFComponent,
  },
})
export default class PrefrenceFileUnit extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  preferenceFile: any;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  serialNumber: string;
  openAccordian: boolean = false;
  options: any[] = [];
  yLocation: number = 0;
  xLocation: number = 0;
  showMoreOptions: boolean = false;
  fileList: any[] = [];
  mounted() {
    this.fileList = this.preferenceFile.hasOwnProperty('prefFileList') ?  this.preferenceFile.prefFileList : [];
    if (this.fileList.length > 0) {
      this.fileList.map((file: any, index: number) => {
        file.showMoreOption = false;
        file.fileID = `fileId${index}`;
      });
    }
  }
  handleAccordian() {
    this.openAccordian = !this.openAccordian;
  }
  moreOptions(event: MouseEvent, selectedFile: any) {
    this.xLocation = 0;
    this.yLocation = 0;
    const productDetailWrapper = document.getElementById('cloudbackups');
    let WIDTH_EXCEPT_PRODUCTDETAIL = window.screenX;
    let HEIGHT_EXCEPT_PRODUCTDETAIL = window.screenY;
    if (productDetailWrapper) {
      const productDetailHeight = productDetailWrapper.getBoundingClientRect().height;
      const productDetailWidth =  productDetailWrapper.getBoundingClientRect().width;
      WIDTH_EXCEPT_PRODUCTDETAIL = window.innerWidth - productDetailWidth;
      HEIGHT_EXCEPT_PRODUCTDETAIL = window.innerHeight - productDetailHeight;
      this.yLocation = event.clientY - HEIGHT_EXCEPT_PRODUCTDETAIL;
      this.yLocation += productDetailWrapper.scrollTop - event.offsetY - 22;
      this.xLocation = event.clientX - WIDTH_EXCEPT_PRODUCTDETAIL + event.offsetX + 30;
    }
    this.fileList.map((file: any) => {
      if (selectedFile.fileID === file.fileID) {
        file.showMoreOption = true;
      } else {
        file.showMoreOption = false;
      }
    });
    this.$forceUpdate();
    event.stopPropagation();
  }
  updated() {
    if (this.fileList.filter(file => file.showMoreOption).length > 0) {
      window.addEventListener('click', () => {
        this.fileList.map((file: any) => {
          file.showMoreOption = false;
        });
        this.$forceUpdate();
      });
    }
  }
  destroy() {
    window.removeEventListener('click', () => {
      this.showMoreOptions = false;
    });
  }
  get getFileList() {
    return this.fileList;
  }
  toggleGold(file: any) {
    const request = {
      serialNumber: this.serialNumber,
      fileId: file.prefFileID,
      operation: 'tgold',
    };
    this.$store.dispatch('MswProductsStoreModule/bacupPrefOperation', request)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp && resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else if (resp && resp.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          this.$emit('update-cloud-backups');
        }
      })
      .catch((errorResp: any) => {
        this.$store.commit('stopLoading');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: errorResp.msgDesc });
      });
  }
  toggleLock(file: any) {
    if (file.goldStandard !== '1') {
      const request = {
        serialNumber: this.serialNumber,
        fileId: file.prefFileID,
        operation: 'tlock',
      };
      this.$store.dispatch('MswProductsStoreModule/bacupPrefOperation', request)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp && resp.operationStatus === 'NOK') {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          } else if (resp && resp.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            this.$emit('update-cloud-backups');
          }
        })
        .catch((errorResp: any) => {
          this.$store.commit('stopLoading');
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: errorResp.msgDesc });
        });
    }
  }
  delPrefFile(file: any) {
    const deleteAllowed = file.goldStandard === '1' ||  file.pinIt === '1';
    if (!deleteAllowed) {
      const request = {
        serialNumber: this.serialNumber,
        fileId: file.prefFileID,
        operation: 'del',
      };
      this.$store.dispatch('MswProductsStoreModule/bacupPrefOperation', request)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp && resp.operationStatus === 'NOK') {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          } else if (resp && resp.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            this.$emit('update-cloud-backups');
          }
        })
        .catch((errorResp: any) => {
          this.$store.commit('stopLoading');
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: errorResp.msgDesc });
        });
    }
  }
  downloadPrefFile(file: any) {
    const request = {
      serNo: this.serialNumber,
      fileId: file.prefFileID,
    };
    this.$store.dispatch('MswProductsStoreModule/downloadPrefFile', request)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp && resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else if (resp && resp.operationStatus === 'OK') {
          const blob = new Blob([resp.fileContent], { type: 'application/octet-stream' });
          if (detectIE()) {
            window.navigator.msSaveBlob(blob, resp.fileName);
          } else {
            const elDownloadPrefFile = document.createElement('a');
            elDownloadPrefFile.setAttribute('type', 'hidden');
            elDownloadPrefFile.href = window.URL.createObjectURL(blob);
            elDownloadPrefFile.download = resp.fileName;
            document.body.appendChild(elDownloadPrefFile);
            elDownloadPrefFile.click();
          }
        }
      })
      .catch((errResp: any) => {
        this.$store.commit('stopLoading');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: errResp.msgDesc });
      });
  }
}
